goog.module('yext.developerapps.tableauconnector.ConnectionData');
goog.module.declareLegacyNamespace();

/**
 */
class ConnectionData {
  constructor(connectionData) {
    this.set = this.set.bind(this);
    this.get = this.get.bind(this);
    this.getJson = this.getJson.bind(this);
    this.setDefault = this.setDefault.bind(this);

    this.getDataType = this.getDataType.bind(this);
    this.setDataType = this.setDataType.bind(this);
    this.getDateRange = this.getDateRange.bind(this);
    this.setDateRange = this.setDateRange.bind(this);
    this.getStartDate = this.getStartDate.bind(this);
    this.setStartDate = this.setStartDate.bind(this);
    this.getEndDate = this.getEndDate.bind(this);
    this.setEndDate = this.setEndDate.bind(this);
    this.setCustomDates = this.setCustomDates.bind(this);

    this.isDataType = this.isDataType.bind(this);
    this.isDateRange = this.isDateRange.bind(this);
    this.validateCustomDates = this.validateCustomDates.bind(this);
  }

  set(connectionData) {
    this.dataType = connectionData['data'];
    this.dateRange = connectionData['date-range'];
    this.startDate = connectionData['custom-dates']['start-date'];
    this.endDate = connectionData['custom-dates']['end-date'];
  }

  get() {
    return this;
  }

  getJson() {
    return {
      'data': this.dataType,
      'date-range': this.dateRange,
      'custom-dates': {'start-date': this.startDate, 'end-date': this.endDate},
    };
  }

  setDefault() {
    this.dataType = 'analytics';
    this.dateRange = '90-day';
    this.startDate = '';
    this.endDate = '';
  }

  getDataType() {
    return this.dataType;
  }

  setDataType(dataType) {
    this.dataType = dataType;
    return this;
  }

  getDateRange() {
    return this.dateRange;
  }

  setDateRange(dateRange) {
    this.dateRange = dateRange;
    return this;
  }

  getStartDate() {
    return this.startDate;
  }

  setStartDate(startDate) {
    this.startDate = startDate;
    return this;
  }

  getEndDate() {
    return this.endDate;
  }

  setEndDate(endDate) {
    this.endDate = endDate;
    return this;
  }

  setCustomDates(startDate, endDate) {
    this.startDate = startDate;
    this.endDate = endDate;
    return this;
  }

  isDataType(dataType) {
    return this.dataType == dataType;
  }

  isDateRange(dateRange) {
    return this.dateRange == dateRange;
  }

  validateCustomDates() {
    var startDate = this.startDate;
    var endDate = this.endDate;
    console.log('Inside validateCustomDates');

    if (startDate.length == 0 || endDate.length == 0) {
      throw new Error('Missing date value');
    }
    if (isNaN(Date.parse(startDate)) || isNaN(Date.parse(endDate))) {
      throw new Error('Invalid date - please use MM/DD/YYYY format');
    }
    if (Date.parse(startDate) >= Date.parse(endDate)) {
      throw new Error('Invalid date range');
    }
  }

  static formatDate(time) {
    var date = new Date(time);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if (dd < 10) {
      dd ='0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    return mm + '/' + dd + '/' + yyyy;
  }
}

exports = ConnectionData;
